var OSS = require('ali-oss')
export function client() {
  const client = new OSS({
    region : 'oss-cn-beijing',
      accessKeyId : 'LTAI5tPMdMMLWab1hqyuXwYZ',
      accessKeySecret : 'd5d97f1i4pyLzLoh9aXDwWHLQcVjhx',
      bucket : 'hua-xi'
  })
  return client
}


// WEBPACK FOOTER //
// ./src/common/js/alioss.js